export class WpLineaDto {
    public id: number = 0;
    public name: string = "";
    public quantity: number = 0;
    public total: string = "";
    public price: number = 0;

    constructor(data?: any) {
        if (!data) return;
        this.id       = data.id || 0;
        this.name     = data.name || "";
        this.quantity = data.quantity || 0;
        this.total    = data.total || "";
        this.price    = data.price || 0;
    }
}

export class WpPedidoDto {
    public id: number = 0;
    public number: string = "";
    public status: string = "";
    public date_created: string = "";
    public total: string = "";
    public currency: string = "EUR";
    public billing_first_name: string = "";
    public billing_last_name: string = "";
    public billing_email: string = "";
    public billing_phone: string = "";
    public customer_note: string = "";
    public line_items: WpLineaDto[] = [];
    public payment_method_title: string = "";

    constructor(data?: any) {
        if (!data) return;
        this.id                   = data.id || 0;
        this.number               = String(data.number || "");
        this.status               = data.status || "";
        this.date_created         = data.date_created || "";
        this.total                = data.total || "";
        this.currency             = data.currency || "EUR";
        this.payment_method_title = data.payment_method_title || "";
        this.customer_note        = data.customer_note || "";
        this.line_items           = (data.line_items || []).map((x: any) => new WpLineaDto(x));
        const b = data.billing || {};
        this.billing_first_name = b.first_name || "";
        this.billing_last_name  = b.last_name  || "";
        this.billing_email      = b.email      || "";
        this.billing_phone      = b.phone      || "";
    }

    get clienteNombre(): string {
        const n = `${this.billing_first_name} ${this.billing_last_name}`.trim();
        return n || "—";
    }
}
